<mat-card appearance="outlined" style="margin: 16px; padding: 16px;">
    <mat-card-content>
        <div class="filter-container">
            <mat-form-field appearance="outline">
                <mat-label>Ddt Nr</mat-label>
                <input #ddtNrF [disabled]="operationInExecution" matInput>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Vendor</mat-label>
                <input #vendorF [disabled]="operationInExecution" matInput>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <input #noteF [disabled]="operationInExecution" matInput>
            </mat-form-field>
        </div>

        <div>
            <mat-tab-group (selectedIndexChange)="selectedTab = $event" [selectedIndex]="selectedTab">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span matTooltip="Lista veloce">Delivery notes list</span>
                    </ng-template>

                    <app-ddt-list-table [reloadDataSubject]="reloadDataSubject" searchMode='quick'></app-ddt-list-table>
                </mat-tab>

                <mat-tab>
                    @if (performingSlowSearch$ | async) {
                        <ng-template mat-tab-label>
                            <div class="tab-label-loading">
                                <mat-icon matTooltip="Searching...">cloud_sync</mat-icon>
                            </div>
                        </ng-template>
                    } @else {
                        <ng-template mat-tab-label>
                            <div class="tab-label-loaded">
                                <mat-icon matTooltip="Lista esaustiva ({{slowListElements}} delivery notes)">cloud_done</mat-icon>
                                <span>({{ slowListElements }})</span>
                            </div>
                        </ng-template>
                    }

                    <app-ddt-list-table (updateTotalElements)="slowListElements = $event" [reloadDataSubject]="reloadDataSubject"
                                        searchMode='slow'
                    ></app-ddt-list-table>
                </mat-tab>
            </mat-tab-group>
        </div>
    </mat-card-content>
</mat-card>
